import React from "react";
import s from "./NewSectionModal.module.scss";
import Modal from "../../common/Modal";
import Button from "../../common/Button";
import {appRoutePaths} from "../../../config/config";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../../redux/hooks";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";

export interface INewSectionModalProps {
  sectionNumber: number;
  sectionName: string;
  sectionDescription: string;
}

// This modal is displayed when a user goes from the end of one section to the start of the next section using Lesson player controls
export default function NewSectionModal({sectionNumber, sectionName, sectionDescription}: INewSectionModalProps) {
  const lesson = useAppSelector(lessonPlayerStore.getLesson);
  const lessonId = parseInt(lesson?.id ?? "", 10);
  const displayNewSectionModalForLesson = useAppSelector(lessonPlayerStore.getDisplayNewSectionModalForLesson);

  const navigate = useNavigate();

  function goTo(displayNewSectionModalForLessonChanged: (d?: number)=> void, link: string){
    displayNewSectionModalForLessonChanged(undefined);
    navigate(link);
  }

  if (!lessonId || lessonId !== displayNewSectionModalForLesson) { return null; }

  return (
    <Modal additionalClassName={s.newSectionModal}>
      <div className={s.container}>
        <div className={s.contentGrid}>
          <div className={s.sectionNumber}>{sectionNumber}</div>
          <div>
            <div className={s.lessonName}>{sectionName}</div>
            <div className={s.lessonDescription}>{sectionDescription}</div>
          </div>
          <div className={s.actionButtons}>
            <Button
              buttonType={'secondary'}
              additionalClassName={s.outlineButton}
              text={'Go to Bootcamp'}
              navigationNote={'C'}
              onClick={() => {
                goTo((lessonId?: number) => { lessonPlayerStore.setDisplayNewSectionModalForLesson(lessonId)}, appRoutePaths.bootCampPage);
              }}
            />
            <Button
              buttonType={'primary'}
              text={'Start Section'}
              navigationNote={'D'}
              onClick={(lessonId?: number) => { lessonPlayerStore.setDisplayNewSectionModalForLesson(lessonId); }}
            />
          </div>
        </div>

      </div>
    </Modal>
  );
}
